import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { userPageType, USER_TYPE } from "../utils/enum";
import { TbRestore } from "react-icons/tb";
import debounce from "lodash/debounce";
import useApi from "../hook/useApi";
import Paggination from "./Paggination";
import Loader from "./Loader/Loader";
import {
  copyToClipboard,
  formatDateInAMPM,
  trimAddress,
} from "../utils/helper";
import { IoCopyOutline } from "react-icons/io5";
import { BASE_URL, STANDARD_IMAGE_URL } from "../utils/constant";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const UsersListLayer = () => {
  const { AsyncGetApiCall, AsyncDeleteApiCall } = useApi();
  const navigate = useNavigate();
  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: 50,
    search: "",
    isVerified: null,
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const setPageNo = (pageNo) => {
    setQuery((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
  };

  const getAllUsersList = async (/* showLoader = true */) => {
    // if (showLoader) {
    setLoading(true);
    // }
    const result = await AsyncGetApiCall("/users/list", query);
    console.log("Result:", result);

    if (result.success) {
      setData(result);
    }
    // if (showLoader) {
    setLoading(false);
    // }
  };

  const handleViewUser = (id) => {
    navigate(`/view-user-profile/${id}`, {
      state: { from: userPageType.VIEW },
    });
  };

  const handleEditUser = (id) => {
    navigate(`/edit-user-profile/${id}`, {
      state: { from: userPageType.UPDATE },
    });
  };

  const handleSearchUser = (e) => {
    const value = e.target.value;
    const validChars = /^[a-zA-Z0-9\s_]*$/; // Only alphanumeric characters allowed

    if (!value.trim()) {
      setQuery((prev) => ({ ...prev, search: "", pageNo: 1 }));
    } else if (validChars.test(value)) {
      setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
    }
  };

  // Prevent form submission
  const handleFormSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    getAllUsersList();
  }, [query]);

  const imageUrl = data?.data?.[0]?.profileImage
    ? `${BASE_URL}/uploads/${data?.data?.[0]?.profileImage}`
    : STANDARD_IMAGE_URL;

  const handleExport = (type) => {
    if (!data?.data?.length) {
      toast.warning("No data to export!");
      return;
    }

    const exportData = data.data.map((user, index) => ({
      "S.No": (data.currentPage - 1) * query.limitVal + index + 1,
      Name: user?.name?.trim() || "N/A",
      "User Name": user?.userName?.trim() || "N/A",
      "Wallet Address": user?.walletAddress || "N/A",
      Email: user?.email || "N/A",
      "Is Verified": user?.isVerified ? "Yes" : "No",
      "Created At": formatDateInAMPM(user?.createdAt) || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData, { origin: "A1" });

    const colWidths = Object.keys(exportData[0]).map((key) => ({
      wch: Math.max(key.length + 2, 15),
    }));
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users_List");

    if (type === "csv") {
      const csv = XLSX.utils.sheet_to_csv(ws);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `Users_List_${new Date().toISOString().split("T")[0]}.csv`);
    } else {
      XLSX.writeFile(
        wb,
        `Users_List_${new Date().toISOString().split("T")[0]}.xlsx`
      );
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <span className="text-md fw-medium text-secondary-light mb-0">
              Show
            </span>
            <select
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={query.limitVal} // Changed from defaultValue to value
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                setQuery((prev) => ({
                  ...prev,
                  limitVal: value,
                  pageNo: 1, // Reset to first page on limit change
                }));
              }}
            >
              {/* <option value="5">5</option> */}
              {Array.from({ length: 20 }, (_, i) => {
                const value = (i + 1) * 5;
                return (
                  <option key={value} value={value}>
                    {value}
                  </option>
                );
              })}
            </select>
            <form className="navbar-search" onSubmit={handleFormSubmit}>
              <input
                type="text"
                className="bg-base h-50-px w-auto"
                name="search"
                placeholder="Search by name, user name, wallet address"
                value={query.search}
                onChange={handleSearchUser}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>
            <div className="d-flex align-items-center gap-2">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => handleExport("csv")}
              >
                Export CSV
              </button>
              <button
                className="btn btn-outline-success btn-sm"
                onClick={() => handleExport("excel")}
              >
                Export Excel
              </button>
            </div>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      S.No
                    </div>
                  </th>
                  <th scope="col">Name</th>
                  <th scope="col">User Name</th>
                  <th scope="col">Wallet Address</th>
                  <th scope="col">Created At</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data && data.data?.length > 0 ? (
                  data.data.map((user, index) => (
                    <tr key={user?._id}>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-10">
                          {(data?.currentPage - 1) * query.limitVal + index + 1}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              user?.profileImage
                                ? `${user?.profileImage}`
                                : "https://wow-dash.com/demo/assets/images/user.png"
                            }
                            alt="Wowdash"
                            className="w-40-px h-40-px rounded-circle flex-shrink-0 me-12 overflow-hidden"
                          />
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {user?.name || "N/A"}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {user?.userName || "N/A"}
                        </span>
                      </td>
                      <td>
                        {trimAddress(user?.walletAddress, 6, 6) || "N/A"}
                        {user?.walletAddress && (
                          <button
                            onClick={() => copyToClipboard(user?.walletAddress)}
                            className="ms-3 p-0 border-0 bg-transparent"
                            style={{ lineHeight: 1 }}
                          >
                            <IoCopyOutline />
                          </button>
                        )}
                      </td>
                      <td>{formatDateInAMPM(user?.createdAt)}</td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <button
                            type="button"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => handleViewUser(user?._id)}
                          >
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                            <span className="tooltip-text">View</span>
                          </button>
                          <button
                            type="button"
                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => handleEditUser(user?._id)}
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                            <span className="tooltip-text">Edit</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paggination
            total={data?.total || 0}
            totalPages={data?.totalPages || 0}
            currentPage={data?.currentPage || 0}
            setPageNo={setPageNo}
            startFrom={(data?.currentPage - 1) * query.limitVal + 1}
            endTo={
              (data?.currentPage - 1) * query.limitVal + data?.data?.length
            }
          />
        </div>
      </div>
    </>
  );
};

export default UsersListLayer;
